export default "__VITE_ASSET__zTfrPH7Z__"